import React from 'react';
import './text-button.css';
import PropTypes from 'prop-types';
import { Paragraph } from '../paragraph';
import { Icon } from '../icon';
import classNames from 'classnames';

const TextButton = props => {
    const { text, onClick, isDisabled, pressGame } = props;

    const textButtonClasses = classNames({
        'text-button': true,
        'text-button--press': pressGame === true,
    });

    return (
        <button
            onClick={onClick}
            className={textButtonClasses}
            disabled={isDisabled}
        >
            <Paragraph withSpacing={false} verticalAlign="top">
                {text}
            </Paragraph>
            <div className="text-button__icon">
                <Icon iconName="arrow" size="small" altText="" />
            </div>
        </button>
    );
};

TextButton.defaultProps = {
    isDisabled: false,
};

TextButton.propTypes = {
    text: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    pressGame: PropTypes.bool,
};

export { TextButton };
